export default __webpack_public_path__ + "9858c4f922309d5a8bb76adc13ad0a92.png";